import {
    APP_URL_HOME,
    BAD_REQUEST,
    REQUEST_FAILED,
    SERVER_ERROR,
    UNAUTHORIZED_RESPONSE_CODE_REFRESH,
    UNAUTHORIZED_RESPONSE_CODE_REJECT
} from '../const';
import { store } from '../store';
import { logOut } from '../store/slices/authSlice';
import RequestsApi from './RequestsApi';
import ToastifyService, { TOAST_NOTIFY_TYPES } from './ToastifyService';

class ResponseService {
    constructor() {
        this.inited = false;
    }

    init() {
        if (this.inited) {
            return;
        }

        const listeners = {
            [UNAUTHORIZED_RESPONSE_CODE_REFRESH]: () => {
                store.dispatch(logOut(true));
            },
            [UNAUTHORIZED_RESPONSE_CODE_REJECT]: () => {
                store.dispatch(logOut(true));
            },
            [REQUEST_FAILED]: () => {
                window.location.replace(APP_URL_HOME);
            },
            [SERVER_ERROR]: () => {
                ToastifyService.setToast('Something went wrong', TOAST_NOTIFY_TYPES.ERROR);
            },
            [BAD_REQUEST]: (error) => {
                ToastifyService.setToast(error?.response?.data?.error, TOAST_NOTIFY_TYPES.ERROR);
            }
        };

        RequestsApi.addResponseListener(
            async (response) => {
                listeners[response.status]?.();
                return response;
            },
            async (error) => {
                (await typeof listeners[error?.response?.status]) === 'function'
                    ? listeners[error?.response?.status](error)
                    : ToastifyService.setToast(error?.response?.data?.error || 'Something went wrong', TOAST_NOTIFY_TYPES.ERROR);

                return Promise.reject(error);
            }
        );

        this.inited = true;
    }
}

export default new ResponseService();
